<template>
    <div class='bg-white  index'>
        <div style="display: flex; width: 100%;">
            <div class="leftbox">
                <el-card class="box-card" :style="pageHeight" body-style="padding:0px" style="overflow-y: auto;">
                    <div style="width: 450px;">
                        <div style="padding: 10px;">
                            <el-form :inline="true" class="slot-special-filter">
                                <!-- <el-form-item>
                                    <el-date-picker v-model="timed" type="daterange" range-separator="至"
                                        start-placeholder="开始日期" end-placeholder="结束日期" size="small"
                                        value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item> -->
                                <el-form-item>
                                    <el-select v-model="ks_value" placeholder="请选择机构" size='small' class="bwidths"
                                        @change="closeks_value" clearable>
                                        <el-option v-for="item in  ks_options" :key="item.id" :label="item.name"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-select v-model="dhfs_value" placeholder="请选择电话" size='small' class="bwidths">
                                        <el-option v-for="item in  dhfs_options" :key="item.id" :label="item.name"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-select v-model="wxfs_value" placeholder="请选择微信" size='small' class="bwidths">
                                        <el-option v-for="item in  wxfs_options" :key="item.id" :label="item.name"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-select v-model="qqfs_value" placeholder="请选择QQ" size='small' class="bwidths">
                                        <el-option v-for="item in  qqfs_options" :key="item.id" :label="item.name"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-select v-model="qds_value" multiple collapse-tags placeholder="请选择渠道"
                                        size='small' class="bwidths">
                                        <el-option v-for="item in  qds_options" :key="item.id" :label="item.name"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-select v-model="lx_value" placeholder="请选择数据来源" size='small' class="bwidths">
                                        <el-option v-for="item in  lx_options" :key="item.id" :label="item.name"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="发送次数">
                                    <el-input placeholder="请输入数字0,1,2" v-model="lxfsname" type="number" size='small'
                                        class="mr_tp">
                                        <el-select v-model="fs_value" slot="prepend" placeholder="请选择" size='small'
                                            class="bwidths">
                                            <el-option v-for="item in  fs_options" :key="item.id" :label="item.name"
                                                :value="item.id"></el-option>
                                        </el-select>
                                    </el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-select v-model="jds_value" multiple collapse-tags placeholder="请选择阶段"
                                        size='small' class="bwidthed">
                                        <el-option v-for="item in  jds_options" :key="item.id" :label="item.name"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="begins" size="small">搜索
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div>
                            <el-row>
                                <el-col :span="5">
                                    <el-menu :default-active="activeIndex" class="el-menu-demo" @select="handleSelect">
                                        <el-menu-item index="1">基础信息</el-menu-item>
                                        <el-menu-item index="2">社会关系</el-menu-item>
                                        <el-menu-item index="3">触媒信息</el-menu-item>
                                        <el-menu-item index="6">互动记录</el-menu-item>
                                        <el-menu-item index="7">消费能力</el-menu-item>
                                        <el-menu-item index="4">医疗信息</el-menu-item>
                                        <el-menu-item index="8">行为特征</el-menu-item>
                                        <el-menu-item index="5">客户关注</el-menu-item>
                                        <el-menu-item index="9">客户建议</el-menu-item>
                                        <el-menu-item index="10">会员与积分</el-menu-item>
                                        <el-menu-item index="11">消费信息</el-menu-item>
                                        <el-menu-item index="12">留存转化</el-menu-item>
                                    </el-menu>
                                </el-col>
                                <el-col :span="18">
                                    <el-form ref="ruleForm" :inline="true" class="slot-special-filter"
                                        :label-position="labelPosition">
                                        <div v-show="activeIndex==1">
                                            <el-col :span="12">
                                                <el-form-item class="bqys" label-width="40px">
                                                    <el-input placeholder="请输入姓名" v-model.trim="xmname" clearable
                                                        size="small">
                                                    </el-input>
                                                </el-form-item>
                                                <el-form-item class="bqys">
                                                    <el-select v-model="xb_value" filterable clearable
                                                        placeholder="请选择性别" size="small" class="widthfixx">
                                                        <el-option v-for="item in xb_options" :key="item.id"
                                                            :label="item.type_name" :value="item.type_name">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item class="bqys">
                                                    <el-select v-model="nl_value" filterable clearable
                                                        placeholder="请选择年龄" size="small" class="widthfixx">
                                                        <el-option v-for="item in nl_options" :key="item.id"
                                                            :label="item.content_name" :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item class="bqys">
                                                    <el-input placeholder="请输入身高" v-model.trim="sgname" clearable
                                                        size="small">
                                                    </el-input>
                                                </el-form-item>
                                                <el-form-item class="bqys">
                                                    <el-input placeholder="请输入体重" v-model.trim="tzname" clearable
                                                        size="small">
                                                    </el-input>
                                                </el-form-item>
                                                <el-form-item class="bqys">
                                                    <!-- <el-input placeholder="请输入居住地址" v-model.trim="jzdzname" clearable
                                                            size="small">
                                                        </el-input> -->
                                                    <div class="dqxx">
                                                        <div>
                                                            <el-select v-model="xzdz" clearable placeholder="请选择居住地址"
                                                                size="small" @change="getlzxx1">
                                                                <el-option v-for="(item,index) in xzdz_adress1"
                                                                    :key="index" :label="item.name" :value="item.code">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                        <div>
                                                            <el-select v-model="xzdz2" clearable placeholder="请选择"
                                                                size="small" @change="getlzxx2">
                                                                <el-option v-for="(item,index) in xzdz_adress2"
                                                                    :key="index" :label="item.name" :value="item.code">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                    </div>
                                                    <div class="dqxx">
                                                        <div>
                                                            <el-select v-model="xzdz3" clearable placeholder="请选择3"
                                                                size="small" @change="getlzxx3">
                                                                <el-option v-for="(item,index) in xzdz_adress3"
                                                                    :key="index" :label="item.name" :value="item.code">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                        <div>
                                                            <el-select v-model="xzdz4" clearable placeholder="请选择"
                                                                size="small">
                                                                <el-option v-for="(item,index) in xzdz_adress4"
                                                                    :key="index" :label="item.name" :value="item.code">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                    </div>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item class="bqys">
                                                    <el-select v-model="xl_value" filterable clearable
                                                        placeholder="请选择学历" size="small" class="widthfixx">
                                                        <el-option v-for="item in xl_options" :key="item.id"
                                                            :label="item.content_name" :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item class="bqys">
                                                    <el-select v-model="zy_value" filterable clearable
                                                        placeholder="请选择职业" size="small" class="widthfixx">
                                                        <el-option v-for="item in zy_options" :key="item.id"
                                                            :label="item.content_name" :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item class="bqys">
                                                    <el-select v-model="hy_value" filterable clearable
                                                        placeholder="请选择行业" size="small" class="widthfixx">
                                                        <el-option v-for="item in hy_options" :key="item.id"
                                                            :label="item.content_name" :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item class="bqys">
                                                    <el-select v-model="hf_value" filterable clearable
                                                        placeholder="请选择婚姻" size="small" class="widthfixx">
                                                        <el-option v-for="item in hf_options" :key="item.id"
                                                            :label="item.content_name" :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item class="bqys">
                                                    <el-select v-model="ywsh_value" filterable clearable
                                                        placeholder="请选择生育" size="small" class="widthfixx">
                                                        <el-option v-for="item in ywsh_options" :key="item.id"
                                                            :label="item.content_name" :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item class="bqys">
                                                    <div class="dqxx">
                                                        <div>
                                                            <el-select v-model="gzdz" clearable placeholder="请选择工作地址"
                                                                size="small" @change="getlzxx5">
                                                                <el-option v-for="(item,index) in gzdz_adress5"
                                                                    :key="index" :label="item.name" :value="item.code">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                        <div>
                                                            <el-select v-model="gzdz2" clearable placeholder="请选择"
                                                                size="small" @change="getlzxx6">
                                                                <el-option v-for="(item,index) in gzdz_adress6"
                                                                    :key="index" :label="item.name" :value="item.code">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                    </div>
                                                    <div class="dqxx">
                                                        <div>
                                                            <el-select v-model="gzdz3" clearable placeholder="请选择"
                                                                size="small" @change="getlzxx7">
                                                                <el-option v-for="(item,index) in gzdz_adress7"
                                                                    :key="index" :label="item.name" :value="item.code">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                        <div>
                                                            <el-select v-model="gzdz4" clearable placeholder="请选择"
                                                                size="small">
                                                                <el-option v-for="(item,index) in gzdz_adress8"
                                                                    :key="index" :label="item.name" :value="item.code">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                    </div>
                                                </el-form-item>
                                            </el-col>
                                        </div>
                                        <div v-show="activeIndex==2">
                                            <el-form-item class="bqys">
                                                <el-select v-model="jt_value" filterable clearable placeholder="请选择社会关系"
                                                    size="small" class="widthfixx">
                                                    <el-option v-for="item in jt_options" :key="item.id"
                                                        :label="item.content_name" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <!-- <el-form-item label="生育" class="bqys">
                                                        <el-select v-model="sy_value" filterable clearable placeholder="请选择"
                                                            size="small" class="widthfixx">
                                                            <el-option v-for="item in sy_options" :key="item.id"
                                                                :label="item.type_name" :value="item.type_name">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item> -->
                                        </div>
                                        <div v-show="activeIndex==3">
                                            <el-form-item class="bqys">
                                                <el-select v-model="qd_value" filterable clearable multiple
                                                    collapse-tags placeholder="请选择来源渠道" size="small" class="widthfixx">
                                                    <el-option v-for="item in qd_options" :key="item.id"
                                                        :label="item.content_name" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-select v-model="sjxh_value" filterable clearable
                                                    placeholder="请选择手机型号" size="small" class="widthfixx">
                                                    <el-option v-for="item in sjxh_options" :key="item.id"
                                                        :label="item.content_name" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-select v-model="sjjg_value" filterable clearable
                                                    placeholder="请选择手机价格" size="small" class="widthfixx">
                                                    <el-option v-for="item in sjjg_options" :key="item.id"
                                                        :label="item.content_name" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-select v-model="yys_value" filterable clearable placeholder="请选择运营商"
                                                    size="small" class="widthfixx">
                                                    <el-option v-for="item in yys_options" :key="item.id"
                                                        :label="item.content_name" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-select v-model="lwhj_value" filterable clearable
                                                    placeholder="请选择联网环境" size="small" class="widthfixx">
                                                    <el-option v-for="item in lwhj_options" :key="item.id"
                                                        :label="item.content_name" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-select v-model="sbmc_value" filterable clearable
                                                    placeholder="请选择设备类型" size="small" class="widthfixx">
                                                    <el-option v-for="item in sbmc_options" :key="item.id"
                                                        :label="item.content_name" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-select v-model="swcj_value" filterable clearable
                                                    placeholder="请选择上网场景" size="small" class="widthfixx">
                                                    <el-option v-for="item in swcj_options" :key="item.id"
                                                        :label="item.content_name" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-select v-model="xxpt_value" filterable clearable
                                                    placeholder="请选择XX平台" size="small" class="widthfixx">
                                                    <el-option v-for="item in xxpt_options" :key="item.id"
                                                        :label="item.content_name" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <!-- <el-form-item label="因何选择我院" class="bqys">
                                                        <el-select v-model="yhxzwy_value" filterable clearable multiple
                                                            collapse-tags placeholder="请选择" size="small" class="widthfixx">
                                                            <el-option v-for="item in yhxzwy_options" :key="item.id"
                                                                :label="item.content_name" :value="item.id">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item> -->
                                        </div>
                                        <div v-show="activeIndex==4">
                                            <el-form-item class="bqys">
                                                <el-select v-model="ycjb_value" filterable clearable multiple
                                                    collapse-tags placeholder="请选择预测疾病" size="small" class="widthfixx">
                                                    <el-option v-for="item in ycjb_options" :key="item.id"
                                                        :label="item.content_name" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-select v-model="yb_value" filterable clearable placeholder="请选择有无社保"
                                                    size="small" class="widthfixx">
                                                    <el-option v-for="item in yb_options" :key="item.id"
                                                        :label="item.type_name" :value="item.type_name">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                        <div v-show="activeIndex==5">
                                            <el-form-item class="bqys">
                                                <el-select v-model="khgz_value" filterable clearable multiple
                                                    collapse-tags placeholder="请选择客户关注" size="small" class="widthfixx">
                                                    <el-option v-for="item in khgz_options" :key="item.id"
                                                        :label="item.type_name" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                        <div v-show="activeIndex==6">
                                        </div>
                                        <div v-show="activeIndex==7">
                                            <el-form-item class="bqys">
                                                <el-input placeholder="请输入月收入" v-model.trim="ysr" clearable
                                                    size="small">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-input placeholder="请输入月消费" v-model.trim="yxf" clearable
                                                    size="small">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-input placeholder="请输入支付方式" v-model.trim="zffs" clearable
                                                    size="small">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-input placeholder="请输入贷款情况" v-model.trim="dkqk" clearable
                                                    size="small">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-select v-model="xfsp_value" filterable clearable
                                                    placeholder="请选择消费水平" size="small" class="widthfixx">
                                                    <el-option v-for="item in xfsp_options" :key="item.id"
                                                        :label="item.type_name" :value="item.type_name">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                        <div v-show="activeIndex==8">
                                            <el-form-item class="bqys">
                                                <el-select v-model="hyxq_value" filterable clearable
                                                    placeholder="请选择行业兴趣" size="small" class="widthfixx">
                                                    <el-option v-for="item in hyxq_options" :key="item.id"
                                                        :label="item.content_name" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-select v-model="xshpl_value" filterable clearable
                                                    placeholder="请选择性生活频率" size="small" class="widthfixx">
                                                    <el-option v-for="item in xshpl_options" :key="item.id"
                                                        :label="item.content_name" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-select v-model="cxtj_value" filterable clearable
                                                    placeholder="请选择出行方式" size="small" class="widthfixx">
                                                    <el-option v-for="item in cxtj_options" :key="item.id"
                                                        :label="item.type_name" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                        <div v-show="activeIndex==9">
                                            <el-form-item class="bqys">
                                                <el-input placeholder="请输入客户建议" v-model.trim="khjy" clearable
                                                    size="small">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-input placeholder="请输入客户投诉" v-model.trim="khts" clearable
                                                    size="small">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-input placeholder="请输入满意度调查" v-model.trim="myddc" clearable
                                                    size="small">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                        <div v-show="activeIndex==10">
                                            <el-form-item class="bqys">
                                                <el-input placeholder="请输入会员级别" v-model.trim="hyjb" clearable
                                                    size="small">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-input placeholder="请输入积分赚取" v-model.trim="jfzq" clearable
                                                    size="small">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-input placeholder="请输入积分兑换" v-model.trim="jfdh" clearable
                                                    size="small">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                        <div v-show="activeIndex==11">
                                            <el-form-item class="bqys">
                                                <el-input placeholder="请输入医疗消费信息" v-model.trim="ylxfxx" clearable
                                                    size="small">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-input placeholder="请输入非医疗消费信息" v-model.trim="fylxfxx" clearable
                                                    size="small">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                        <div v-show="activeIndex==12">
                                            <el-form-item class="bqys">
                                                <el-select v-model="zhfl_value" filterable clearable
                                                    placeholder="请选择转化分类" size="small" class="widthfixx">
                                                    <el-option v-for="item in zhfl_options" :key="item.id"
                                                        :label="item.type_name" :value="item.type_name">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item class="bqys">
                                                <el-select v-model="cdsj_value" filterable clearable
                                                    placeholder="请选择触达时间" size="small" class="widthfixx">
                                                    <el-option v-for="item in cdsj_options" :key="item.id"
                                                        :label="item.type_name" :value="item.type_name">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                    </el-form>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </el-card>
            </div>
            <div style="flex: 1;padding-left: 15px;">
                <el-card :style="pageHeight">
                    <div style="display: flex;">
                        <!-- <div style="margin-bottom: 8px;">
                            <el-button type="primary" @click="sendUP" size="small">发送</el-button>
                        </div> -->
                        <div style="display: flex;align-items: center; font-size: 20px; margin-left: 8px;">总计<span
                                style="color: red;"> <span v-if="!countLoading">{{count}}</span> <i
                                    v-else-if="countLoading" class="el-icon-loading"></i></span>条</div>
                    </div>
                    <div style="margin-top:8px;margin-bottom:8px">
                        <el-input v-model="input" placeholder="请输入内容" style="width:150px;margin-right:10px"
                            size="small"></el-input>
                        <el-select v-model="searchtype" placeholder="请选择" clearable v-if="ks_value==0" size="small"
                            style="width:150px;margin-right:10px">
                            <el-option label="用户" :value="1"></el-option>
                            <el-option label="医生" :value="2"></el-option>
                        </el-select>
                        <el-button type="primary" size="small" @click="xxsearch">详情</el-button>

                    </div>
                    <!-- <div style="display: flex; margin-bottom: 8px;">
                        <div v-if="yysshow == true"
                            style="display: flex;align-items: center; font-size: 20px; margin-left: 8px;">移动<span
                                style="color: red;">{{yd}}</span>条</div>
                        <div v-if="yysshow == true"
                            style="display: flex;align-items: center; font-size: 20px; margin-left: 8px;">电信<span
                                style="color: red;">{{dx}}</span>条</div>
                        <div v-if="yysshow == true"
                            style="display: flex;align-items: center; font-size: 20px; margin-left: 8px;">联通<span
                                style="color: red;">{{lt}}</span>条</div>
                        <div v-if="yysshow == true && qt"
                            style="display: flex;align-items: center; font-size: 20px; margin-left: 8px;">其他<span
                                style="color: red;">{{qt}}</span>条</div>
                    </div> -->

                    <el-tabs v-if="xqshow == true" v-model="yysactiveName" type="card" @tab-click="yyshandleClick"
                        v-loading="tabloading">
                        <!-- <el-badge :value="yd" class="item">
                            <el-tab-pane label="全部" name="1"></el-tab-pane>
                        </el-badge> -->
                        <el-tab-pane name="1">
                            <span slot="label">
                                全部<el-badge :value="qb" class="item"></el-badge>
                            </span>
                        </el-tab-pane>
                        <el-tab-pane name="2">
                            <span slot="label">
                                移动<el-badge :value="yd" class="item"></el-badge>
                            </span>
                        </el-tab-pane>
                        <el-tab-pane name="3">
                            <span slot="label">
                                电信<el-badge :value="dx" class="item"></el-badge>
                            </span>
                        </el-tab-pane>
                        <el-tab-pane name="4">
                            <span slot="label">
                                联通<el-badge :value="lt" class="item"></el-badge>
                            </span>
                        </el-tab-pane>
                        <el-tab-pane name="5">
                            <span slot="label">
                                其他<el-badge :value="qt" class="item"></el-badge>
                            </span>
                        </el-tab-pane>
                        <!-- <el-badge :value="12" class="item">
                            <el-tab-pane label="移动" name="2"></el-tab-pane>
                        </el-badge> -->
                        <!-- <el-badge :value="dx" class="item">
                            <el-tab-pane label="电信" name="3"></el-tab-pane>
                        </el-badge>
                        <el-badge :value="lt" class="item">
                            <el-tab-pane label="联通" name="4"></el-tab-pane>
                        </el-badge>
                        <el-badge :value="qt" class="item">
                            <el-tab-pane label="其他" name="5"></el-tab-pane>
                        </el-badge> -->
                    </el-tabs>
                    <div v-if="yysactiveName == '1'">
                        <div style="margin-bottom: 8px;">
                            <el-button type="primary" @click="sendUP" size="small">发送</el-button>
                        </div>
                        <el-table :data="tableData2" border v-loading="loadings" :height="labelHeight"
                            @selection-change="handleSelectionChange2" highlight-current-row>
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="name" label="姓名" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="sex" label="性别" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="part_id_text" label="部门" show-overflow-tooltip></el-table-column>
                            <!-- <el-table-column prop="integrity" label="完整性" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="accuracy" label="准确性" show-overflow-tooltip></el-table-column> -->
                            <el-table-column prop="age" label="年龄" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="tel" label="电话" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="wx" label="微信" show-overflow-tooltip></el-table-column>
                            <!-- <el-table-column prop="qq" label="QQ" show-overflow-tooltip></el-table-column> -->
                            <el-table-column prop="part_id_text" label="部门" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="create_at" label="添加时间" show-overflow-tooltip></el-table-column>
                        </el-table>
                    </div>
                    <div v-if="yysactiveName == '2'">
                        <div style="margin-bottom: 8px;">
                            <el-button type="primary" @click="sendUP" size="small">发送</el-button>
                        </div>
                        <el-table :data="tableDatayd" border v-loading="loadings" :height="labelHeight"
                            @selection-change="handleSelectionChange2" highlight-current-row>
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="name" label="姓名" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="sex" label="性别" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="part_id_text" label="部门" show-overflow-tooltip></el-table-column>
                            <!-- <el-table-column prop="integrity" label="完整性" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="accuracy" label="准确性" show-overflow-tooltip></el-table-column> -->
                            <el-table-column prop="age" label="年龄" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="tel" label="电话" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="wx" label="微信" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="qq" label="QQ" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="part_id_text" label="部门" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="create_at" label="添加时间" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="create_author" label="添加人" show-overflow-tooltip>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="yysactiveName == '3'">
                        <div style="margin-bottom: 8px;">
                            <el-button type="primary" @click="sendUP" size="small">发送</el-button>
                        </div>
                        <el-table :data="tableDatadx" border v-loading="loadings" :height="labelHeight"
                            @selection-change="handleSelectionChange2" highlight-current-row>
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="name" label="姓名" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="sex" label="性别" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="part_id_text" label="部门" show-overflow-tooltip></el-table-column>
                            <!-- <el-table-column prop="integrity" label="完整性" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="accuracy" label="准确性" show-overflow-tooltip></el-table-column> -->
                            <el-table-column prop="age" label="年龄" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="tel" label="电话" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="wx" label="微信" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="qq" label="QQ" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="part_id_text" label="部门" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="create_at" label="添加时间" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="create_author" label="添加人" show-overflow-tooltip>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="yysactiveName == '4'">
                        <div style="margin-bottom: 8px;">
                            <el-button type="primary" @click="sendUP" size="small">发送</el-button>
                        </div>
                        <el-table :data="tableDatalt" border v-loading="loadings" :height="labelHeight"
                            @selection-change="handleSelectionChange2" highlight-current-row>
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="name" label="姓名" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="sex" label="性别" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="part_id_text" label="部门" show-overflow-tooltip></el-table-column>
                            <!-- <el-table-column prop="integrity" label="完整性" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="accuracy" label="准确性" show-overflow-tooltip></el-table-column> -->
                            <el-table-column prop="age" label="年龄" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="tel" label="电话" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="wx" label="微信" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="qq" label="QQ" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="part_id_text" label="部门" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="create_at" label="添加时间" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="create_author" label="添加人" show-overflow-tooltip>
                            </el-table-column>
                        </el-table>
                    </div>

                    <div v-if="yysactiveName == '5'">
                        <div style="margin-bottom: 8px;">
                            <el-button type="primary" @click="sendUP" size="small">发送</el-button>
                        </div>
                        <el-table :data="tableDataqt" border v-loading="loadings" :height="labelHeight"
                            @selection-change="handleSelectionChange2" highlight-current-row>
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="name" label="姓名" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="sex" label="性别" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="part_id_text" label="部门" show-overflow-tooltip></el-table-column>
                            <!-- <el-table-column prop="integrity" label="完整性" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="accuracy" label="准确性" show-overflow-tooltip></el-table-column> -->
                            <el-table-column prop="age" label="年龄" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="tel" label="电话" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="wx" label="微信" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="qq" label="QQ" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="part_id_text" label="部门" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="create_at" label="添加时间" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="create_author" label="添加人" show-overflow-tooltip>
                            </el-table-column>
                        </el-table>
                    </div>

                    <!-- <div class="list-footer">
                        <div class="foot-bg">
                        </div>
                        <div class="block page_r">
                            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                :current-page="currentPage" :page-sizes="[300, 500, 1000, 3000,5000,10000]"
                                :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="count">
                            </el-pagination>
                        </div>
                    </div> -->
                </el-card>
            </div>
            <el-drawer :visible.sync="drawer" :before-close="handleClose" size="40%">
                <div style="padding:0 10px">
                    <div>
                        <div style="font-size: 15px;margin-left: 10px;">一共选择<span
                                style="color: red;font-size: 20px">{{this.tableData3.length}}</span>条数据</div>
                        <div>
                            <el-tabs v-model="activeName" @tab-click="handleClick">
                                <el-tab-pane label="短息" name="1"></el-tab-pane>
                                <el-tab-pane label="微信" name="2"></el-tab-pane>
                                <el-tab-pane label="朋友圈" name="3"></el-tab-pane>
                            </el-tabs>
                        </div>
                        <div v-show="activeName == 1">
                            <el-tabs v-model="activeName2" @tab-click="handleClick2">
                                <el-tab-pane label="短息营销类素材" name="293"></el-tab-pane>
                                <el-tab-pane label="短息通知类素材" name="292"></el-tab-pane>
                            </el-tabs>
                            <div v-show="activeName2 == 293">
                                <el-tabs :tab-position="tabPosition" style="height: 500px;" v-model="dxleft"
                                    @tab-click="lefthandleClick">
                                    <el-tab-pane v-for="(item,index) in tablechilren" :key="index" :label="item.name"
                                        :name="item.id +''">
                                        <div style="height: 560px; overflow-y: auto;">
                                            <el-button type="primary" size="small" @click="dxfs"
                                                style="margin-bottom: 5px;">发送</el-button>
                                            <el-table :data="dxrightcontent" height="450" style="width: 100%"
                                                @selection-change="handleSelectionChangedx">
                                                <el-table-column type="selection" width="55"></el-table-column>
                                                <el-table-column prop="title" label="标题" width="100"
                                                    show-overflow-tooltip>
                                                </el-table-column>
                                                <el-table-column prop="content" label="内容" show-overflow-tooltip>
                                                </el-table-column>
                                                <el-table-column prop="update_at" label="创建时间" width="100"
                                                    show-overflow-tooltip>
                                                </el-table-column>
                                            </el-table>
                                        </div>

                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                            <div v-show="activeName2 == 292">
                                <el-tabs :tab-position="tabPosition" style="height: 500px;" v-model="dxleft"
                                    @tab-click="lefthandleClick2">
                                    <el-tab-pane v-for="(item,index) in tablechilren" :key="index" :label="item.name"
                                        :name="item.id +''">
                                        <div style="height: 660px; overflow-y: auto;">
                                            <el-button type="primary" size="small" @click="dxfs2"
                                                style="margin-bottom: 5px;">发送</el-button>
                                            <el-table :data="dxrightcontent2" height="450" style="width: 100%"
                                                @selection-change="handleSelectionChangedx">
                                                <el-table-column type="selection" width="55"></el-table-column>
                                                <el-table-column prop="title" label="标题" width="100"
                                                    show-overflow-tooltip>
                                                </el-table-column>
                                                <el-table-column prop="content" label="内容" show-overflow-tooltip>
                                                </el-table-column>
                                                <el-table-column prop="update_at" label="创建时间" width="100"
                                                    show-overflow-tooltip>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                        </div>


                        <div v-show="activeName == 2">
                            <div>
                                <div>
                                    <el-tabs :tab-position="tabPosition" style="height: 500px;" v-model="wxleft"
                                        @tab-click="wxlefthandleClick">
                                        <el-tab-pane v-for="(item,index) in wxtablechilren" :key="index"
                                            :label="item.content_name" :name="item.id +''">
                                            <div style="height: 460px; overflow-y: auto;">
                                                <el-button type="primary" size="small" @click="wxfs"
                                                    style="margin-bottom: 5px;">发送</el-button>
                                                <el-table :data="wxrightcontent" height="450" style="width: 80%"
                                                    @selection-change="handleSelectionChangewx">
                                                    <el-table-column type="selection" width="55"></el-table-column>
                                                    <el-table-column prop="title" label="标题" width="100"
                                                        show-overflow-tooltip>
                                                    </el-table-column>
                                                    <el-table-column prop="content" label="内容" width="200"
                                                        show-overflow-tooltip>
                                                    </el-table-column>
                                                    <el-table-column prop="update_at" label="创建时间" width="100"
                                                        show-overflow-tooltip>
                                                    </el-table-column>
                                                </el-table>
                                            </div>

                                        </el-tab-pane>
                                    </el-tabs>
                                </div>
                            </div>
                        </div>
                        <div v-show="activeName == 3">
                            <div style="height: 750px; overflow-y: scroll; display: flex;">
                                <div>
                                    <el-menu default-active="2" class="el-menu-vertical-demo" @open="handleOpen"
                                        @close="handleCloses" style="width: 120px;" @select="pyqhandleSelect">
                                        <el-submenu v-for="(item , index) in pyqtablechilren" :key="index"
                                            :index="item.id + ''" style="min-width: 100px;">
                                            <template slot="title">
                                                <span>{{item.name}}</span>
                                            </template>
                                            <el-menu-item-group>
                                                <el-menu-item v-for="(item1,index1) in item.child" :key="index1"
                                                    :index="item1.id + ''"
                                                    style="min-width: 100px; padding-left: 10px;">{{item1.name}}
                                                </el-menu-item>
                                            </el-menu-item-group>
                                        </el-submenu>
                                    </el-menu>
                                </div>
                                <div style="margin-left: 10px;">
                                    <el-button type="primary" size="small" style="margin-bottom: 5px;">发送</el-button>
                                    <el-table :data="pyqrightcontent" height="250" style="width: 100%">
                                        <el-table-column type="selection" width="55"></el-table-column>
                                        <el-table-column prop="bt" label="标题" width="120" show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column prop="nr" label="内容" width="300" show-overflow-tooltip>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                tabloading: false,
                tableDatayd: [],
                tableDatadx: [],
                tableDatalt: [],
                tableDataqt: [],
                xqshow: false,
                yysactiveName: '',
                yd: '',
                dx: '',
                lt: '',
                qt: '',
                qb: '',
                // count:'',
                yysshow: false,
                input: '',
                ks_options: [],
                ks_value: '',
                timed: '',
                pyqtablechilren: [],
                dxleft: '0',
                dxleft2: '',
                wxleft: '',
                wxtablechilren: [],
                wxrightcontent: [],
                pyqrightcontent: [],
                tabPosition: 'left',
                tablechilren: [{
                        id: 0,
                        name: '文字短信'
                    },
                    {
                        id: 1,
                        name: '视频短信'
                    }
                ],
                dxrightcontent: [],
                dxrightcontent2: [],
                activeName: '1',
                activeName2: '293',
                drawer: false,
                lxfsname: '',
                lx_value: '1',
                lx_options: [{
                        id: '1',
                        name: '咨询未预约'
                    },
                    {
                        id: '2',
                        name: '预约未到诊'
                    },
                    // {
                    //     id: '3',
                    //     name: '到诊'
                    // },
                ],
                timed: '',
                pageHeight: {
                    height: null
                },
                currentPage: 1,
                pagesize: 300,
                labelPosition: 'right',
                activeIndex: '1',
                isStyle: {
                    height: null,
                    'overflow': 'auto'
                },
                sendNum: 0,
                tiaoshu: 300,
                fas_options: [],
                dxlist: [{
                    fas_value: '2',
                    type_name: '短信'
                }],
                wxlist: [{
                    fas_value: '1',
                    type_name: '微信'
                }],
                fso_options: [],
                sy_options: [{
                    sy_value: '1',
                    type_name: '未生育'
                }, {
                    sy_value: '2',
                    type_name: '已生育'
                }],
                yb_options: [{
                    yb_value: '1',
                    type_name: '有社保'
                }, {
                    yb_value: '2',
                    type_name: '无社保'
                }],
                jt_options: [],
                hy_options: [],
                xb_options: [{
                    xb_value: '1',
                    type_name: '男'
                }, {
                    xb_value: '2',
                    type_name: '女'
                }],
                xfsp_options: [{
                    xfsp_value: '1',
                    type_name: '低消费'
                }, {
                    xfsp_value: '2',
                    type_name: '中消费'
                }, {
                    xfsp_value: '3',
                    type_name: '高消费'
                }],
                zlzx_value: '',
                zlzx_options: [],
                zt_value: '',
                zt_options: [{
                    zt_value: '1',
                    type_name: '已到'
                }, {
                    zt_value: '2',
                    type_name: '未到'
                }],
                sj_value: '',
                sj_options: [],
                hos_id: "",
                begina: false,
                isshow: false,
                // 
                title: '',
                show: true,
                count: 0,
                value1: '',
                daytime: '1',
                // 
                fso_value: '',
                startTime: '',
                endTime: '',
                hy_value: [],
                yb_value: '',
                khfl_value: '',
                qd_value: '',
                zy_value: [],
                gzhj_value: '',
                xl_value: '',
                xqah_value: [],
                cxtj_value: '',
                hyxq_value: '',
                xshpl_value: '',
                sjxh_value: '',
                sjjg_value: '',
                xmname: '',
                ysr: '',
                yxf: '',
                zffs: '',
                dkqk: '',
                khjy: '',
                khts: '',
                myddc: '',
                hyjb: '',
                jfzq: '',
                jfdh: '',
                ylxfxx: '',
                fylxfxx: '',
                fas_value: '2',
                xb_value: '',
                nl_value: '',
                sgname: '',
                tzname: '',
                xzdz: '',
                xzdz2: '',
                xzdz3: '',
                xzdz4: '',
                gzdz: '',
                gzdz2: '',
                gzdz3: '',
                gzdz4: '',
                gzdz: '',
                gzdz2: '',
                gzdz3: '',
                gzdz4: '',
                zhfl_value: '',
                cdsj_value: '',
                gzdzname: '',
                xfsp_value: '',
                jt_value: '',
                sbmc_value: '',
                xxpt_value: '',
                swcj_value: '',
                lwhj_value: '',
                yys_value: '',
                qd_val: '网聊',
                khgz_value: [],
                ycjb_value: [],
                yhxzwy_value: [],
                duoxuan: [],
                dxlist: [],
                biaoq_options: [],
                biaoq_value: [],
                reny_value: '',
                reny_options: [],
                nl_options: [],
                xzdz_adress1: [],
                xzdz_adress2: [],
                xzdz_adress3: [],
                xzdz_adress4: [],
                gzdz_adress5: [],
                gzdz_adress6: [],
                gzdz_adress7: [],
                gzdz_adress8: [],
                khfl_options: [],
                qd_options: [],
                hy_options: [],
                zy_options: [],
                gzhj_options: [],
                xl_options: [],
                xqah_options: [],
                cxtj_options: [],
                hyxq_options: [],
                xshpl_options: [],
                sjxh_options: [],
                sjjg_options: [],
                yys_options: [],
                lwhj_options: [],
                sbmc_options: [],
                xxpt_options: [],
                swcj_options: [],
                yhxzwy_options: [],
                ycjb_options: [],
                khgz_options: [],
                cxfs_value: '',
                cxfs_options: [],
                hf_value: '',
                hf_options: [],
                ywsh_value: '',
                ywsh_options: [],
                fs_value: 1,
                fs_options: [{
                        id: 1,
                        name: '短信'
                    },
                    {
                        id: 2,
                        name: '微信'
                    },
                    {
                        id: 3,
                        name: '朋友圈'
                    },
                ],
                dhfs_value: '',
                dhfs_options: [{
                        id: 0,
                        name: '全部'
                    },
                    {
                        id: 2,
                        name: '有电话'
                    },
                    {
                        id: 1,
                        name: '没电话'
                    },
                ],
                wxfs_value: '',
                wxfs_options: [{
                        id: 0,
                        name: '全部'
                    },
                    {
                        id: 2,
                        name: '有微信'
                    },
                    {
                        id: 1,
                        name: '没微信'
                    },
                ],
                qqfs_value: '',
                qqfs_options: [{
                        id: 0,
                        name: '全部'
                    },
                    {
                        id: 2,
                        name: '有QQ'
                    },
                    {
                        id: 1,
                        name: '没QQ'
                    },
                ],
                qds_value: [],
                qds_options: [{
                        id: 1,
                        name: '网络'
                    },
                    {
                        id: 2,
                        name: '信息引流'
                    },
                    {
                        id: 3,
                        name: '地面营销'
                    },
                    {
                        id: 4,
                        name: '技术引流'
                    },
                    {
                        id: 5,
                        name: '合作引流'
                    },
                    {
                        id: 6,
                        name: '流量聚合'
                    },
                    {
                        id: 7,
                        name: '自媒体'
                    },
                ],
                iswx: false,
                // 
                tableData: [],
                tableData2: [],
                loadings: false,
                countLoading: false,
                labelHeight: null,
                tableData3: [],
                dxxz: [],
                wxxz: [],
                send_time_type_value: 1,
                send_time_type: [{
                        id: 1,
                        name: '立即发送'
                    },
                    {
                        id: 2,
                        name: '定时发送'
                    },
                ],
                task_date: '',
                iszyc: '',
                accounts: '',
                dialogVisibles: false,
                nextsend: [],
                sendloading: false,
                wlqd_value: '',
                // 
                menulist: [],
                kp_value: '',
                kplist: [],
                fsl: '',
                zhfl_options: [{
                    xfsp_value: '1',
                    type_name: '触媒未咨询'
                }, {
                    xfsp_value: '2',
                    type_name: '咨询未预约'
                }, {
                    xfsp_value: '3',
                    type_name: '预约未到诊'
                }, {
                    xfsp_value: '4',
                    type_name: '到诊未就诊'
                }, {
                    xfsp_value: '5',
                    type_name: '就诊未完成路径'
                }, {
                    xfsp_value: '6',
                    type_name: '完成路径'
                }],
                cdsj_options: [{
                    xfsp_value: '1',
                    type_name: '0-30天'
                }, {
                    xfsp_value: '2',
                    type_name: '31-60天'
                }, {
                    xfsp_value: '3',
                    type_name: '61-90天'
                }, {
                    xfsp_value: '4',
                    type_name: '91-120天'
                }, {
                    xfsp_value: '5',
                    type_name: '121-150天'
                }, {
                    xfsp_value: '6',
                    type_name: '151-180天'
                }, {
                    xfsp_value: '7',
                    type_name: '181天以上'
                }],
                jds_value: [],
                jds_options: [{
                        id: 0,
                        name: '0阶'
                    },
                    {
                        id: 1,
                        name: '1阶'
                    },
                    {
                        id: 2,
                        name: '2阶'
                    },
                    {
                        id: 3,
                        name: '3阶'
                    },
                    {
                        id: 4,
                        name: '4阶'
                    },
                    {
                        id: 5,
                        name: '5阶'
                    },
                    {
                        id: 6,
                        name: '6阶'
                    },
                    {
                        id: 9,
                        name: '180天以上'
                    },
                ],
                // 判断是否初期，第一次加载
                inInit: true,
                heights: null,
                searchtype: ''
            };
        },
        watch: {
            fs_value() {
                if (this.fs_value == 3) {
                    this.jds_options = [{
                            id: 7,
                            name: '0~90天'
                        },
                        {
                            id: 8,
                            name: '90~180天'
                        },
                        {
                            id: 9,
                            name: '180天以上'
                        },
                    ]
                } else {
                    this.jds_options = [{
                            id: 0,
                            name: '0阶'
                        },
                        {
                            id: 1,
                            name: '1阶'
                        },
                        {
                            id: 2,
                            name: '2阶'
                        },
                        {
                            id: 3,
                            name: '3阶'
                        },
                        {
                            id: 4,
                            name: '4阶'
                        },
                        {
                            id: 5,
                            name: '5阶'
                        },
                        {
                            id: 6,
                            name: '6阶'
                        },
                        {
                            id: 9,
                            name: '180天以上'
                        },
                    ]
                }
            },
        },
        computed: {
            pickerOptions() {
                let that = this
                return { //当前时间
                    disabledDate: time => {
                        const times = time.getTime()
                        if (that.daytime == 1) {
                            return new Date(that.startTime).getTime() > times
                        }
                        if (that.daytime == 2) {
                            return new Date(that.start).getTime() > times || new Date(that.start1)
                                .getTime() < time.getTime()
                        }
                        if (that.daytime == 3) {
                            return new Date(that.start3).getTime() < times || new Date(that.start4)
                                .getTime() < time.getTime()
                        }
                    }
                };
            }
        },
        created() {},
        mounted() {
            let that = this
            this.dxleft = 0
            this.lefthandleClick()
            that.gettime()
            that.getqd()
            that.getjg()
            // that.search()
            that.getHeight()
            that.getshen()
            // that.getdxnr()
            // 默认打开的初期调用 显示短息营销类素材下的tab
            that.getdx();
        },
        methods: {
            closeks_value(a) {
                if (a != 0) {
                    this.searchtype = ''
                }
            },
            getHeight() {
                let that = this // window.innerHeight   获取动态表格高度
                this.pageHeight.height = window.innerHeight - 50 + 'px'
                this.labelHeight = window.innerHeight - 165 + 'px'
                that.height = window.innerHeight - 400 + 'px'
                window.onresize = () => {
                    this.labelHeight = window.innerHeight - 165 + 'px'
                    that.height = window.innerHeight - 400 + 'px'
                    this.pageHeight.height = window.innerHeight - 50 + 'px'
                }
            },

            gettime() {
                let that = this;
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth() + 1;
                let day = nowDate.getDate();
                month = month > 9 ? month : '0' + month
                day = day > 9 ? day : '0' + day
                const starttime = `${year}-${month}-01`;
                let endTime = `${year}-${month}-${day}`;
                that.timed = [starttime, endTime];

            },
            getjg() {
                let that = this
                that.ks_value = ''
                axios
                    .post("/admin/pc/sendmsg/hospitalSelect", {}, {
                        token: true
                    })
                    .then(response => {
                        that.ks_options = response.data.data
                    })
                    .catch(error => {})

            },
            async getqd(ids) {
                let that = this
                await axios
                    .post("/admin/pc/sendmsg/ResourcePoolParameters", {}, {
                        token: true
                    })
                    .then(res => {
                        var data = res.data.data
                        data.forEach(element => {
                            if (element.id == 11) {
                                var child = element.children
                                if (child) {
                                    child.forEach(ele => {
                                        if (ele.id == 20) {
                                            this.ycjb_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.ycjb_options = a.concat(ele.children)
                                            that.ycjb_value = that.ycjb_options[0].id;
                                        }
                                    });
                                }
                            }
                            if (element.id == 12) {
                                var child = element.children
                                if (child) {
                                    child.forEach(ele => {
                                        if (ele.id == 25) {
                                            this.sjxh_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.sjxh_options = a.concat(ele.children)
                                            // that.sjxh_value = that.sjxh_options[0].id;
                                        }
                                        if (ele.id == 26) {
                                            this.hy_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.hy_options = a.concat(ele.children)
                                            // that.hy_value = that.hy_options[0].id;
                                        }
                                        if (ele.id == 27) {
                                            this.xl_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.xl_options = a.concat(ele.children)
                                            // that.xl_value = that.xl_options[0].id;
                                        }
                                        if (ele.id == 29) {
                                            this.qd_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.qd_options = a.concat(ele.children)
                                            that.qd_value = that.qd_options[0].id;
                                        }
                                        if (ele.id == 114) {
                                            this.yhxzwy_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.yhxzwy_options = a.concat(ele.children)
                                            that.yhxzwy_value = that.yhxzwy_options[0]
                                                .id;
                                        }
                                        if (ele.id == 110) {
                                            this.zy_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.zy_options = a.concat(ele.children)
                                            // that.zy_value = that.zy_options[0].id;
                                        }
                                        if (ele.id == 115) {
                                            this.xqah_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.xqah_options = a.concat(ele.children)
                                            that.xqah_value = that.xqah_options[0].id;
                                        }
                                        if (ele.id == 121) {
                                            this.yys_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.yys_options = a.concat(ele.children)
                                            // that.yys_value = that.yys_options[0].id;
                                        }
                                        if (ele.id == 122) {
                                            this.lwhj_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.lwhj_options = a.concat(ele.children)
                                            // that.lwhj_value = that.lwhj_options[0].id;
                                        }
                                        if (ele.id == 123) {
                                            this.sbmc_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.sbmc_options = a.concat(ele.children)
                                            // that.sbmc_value = that.sbmc_options[0].id;
                                        }
                                        if (ele.id == 124) {
                                            this.nl_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.nl_options = a.concat(ele.children)
                                            // that.nl_value = that.nl_options[0].id;
                                        }
                                        if (ele.id == 150) {
                                            this.hf_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.hf_options = a.concat(ele.children)
                                            // that.hf_value = that.hf_options[0].id;
                                        }
                                        if (ele.id == 151) {
                                            this.ywsh_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.ywsh_options = a.concat(ele.children)
                                            // that.ywsh_value = that.ywsh_options[0].id;
                                        }
                                        if (ele.id == 153) {
                                            this.jt_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.jt_options = a.concat(ele.children)
                                            // that.jt_value = that.jt_options[0].id;
                                        }
                                        if (ele.id == 120) {
                                            this.sjjg_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.sjjg_options = a.concat(ele.children)
                                            // that.sjjg_value = that.sjjg_options[0].id;
                                        }
                                        if (ele.id == 157) {
                                            this.xxpt_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.xxpt_options = a.concat(ele.children)
                                            // that.xxpt_value = that.xxpt_options[0].id;
                                        }
                                        if (ele.id == 158) {
                                            this.swcj_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.swcj_options = a.concat(ele.children)
                                            // that.swcj_value = that.swcj_options[0].id;
                                        }
                                        if (ele.id == 115) {
                                            this.hyxq_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.hyxq_options = a.concat(ele.children)
                                            // that.hyxq_value = that.hyxq_options[0].id;
                                        }
                                        if (ele.id == 154) {
                                            this.xshpl_options = ele.children
                                            var a = [{ // 添加全部标签，设置ID为0
                                                id: 0,
                                                content_name: "全部"
                                            }];
                                            that.xshpl_options = a.concat(ele.children)
                                            // that.xshpl_value = that.xshpl_options[0].id;
                                        }
                                    });
                                }
                            }
                            if (element.id == 15) {
                                this.khfl_options = element.children
                                var a = [{ // 添加全部标签，设置ID为0
                                    id: 0,
                                    type_name: "全部"
                                }];
                                that.khfl_options = a.concat(element.children)
                                that.khfl_value = that.khfl_options[0].id;
                            }
                            if (element.id == 33) {
                                this.cxtj_options = element.children
                                var a = [{ // 添加全部标签，设置ID为0
                                    id: 0,
                                    type_name: "全部"
                                }];
                                that.cxtj_options = a.concat(element.children)
                                // that.cxtj_value = that.cxtj_options[0].id;
                            }
                            if (element.id == 14) {
                                this.khgz_options = element.children
                                var a = [{ // 添加全部标签，设置ID为0
                                    id: 0,
                                    type_name: "全部"
                                }];
                                that.khgz_options = a.concat(element.children)
                                that.khgz_value = that.khgz_options[0].id;
                            }
                        });
                    })
                    .catch(error => {})
            },


            handleSelect(key, keyPath) {
                this.activeIndex = key
            },

            getChildTraffic() {
                let that = this
                that.cxfs_options = [];
                that.cxfs_value = ''
                if (that.cxtj_options.length > 0) {
                    that.cxtj_options.forEach(element => {
                        if (element.id == that.cxtj_value) {
                            that.cxfs_options = element.children
                        }
                    })
                }
            },

            selecttype() {
                let that = this
                this.fso_value = ''
                if (this.fas_value == 2) {
                    this.begin()
                    this.tableData3 = []
                } else {
                    this.tableData2 = []
                    this.tableData3 = []
                }
            },
            begin() {
                let that = this
                if (this.fso_value == 3) {
                    return this.getmiddle()
                }
                that.currentPage = 1
                that.pagesize = 300
                that.search()
            },
            begins() {
                let that = this

                that.currentPage = 1
                that.pagesize = 300
                that.search()




            },
            xxsearch() {
                let that = this
                that.xqshow = true
                that.yysshow = true
                that.loadings = true
                that.tabloading = true
                that.yysactiveName = '1'
                that.qt = ''
                that.yd = ''
                that.dx = ''
                that.lt = ''
                // that.count = ''
                if (this.lx_value == 1) {
                    var url = '/admin/pc/sendmsg/getYyList'
                } else {
                    var url = "/admin/pc/sendmsg/getYyList"
                }
                axios
                    .post(url, {
                        is_zyc_yy: this.lx_value,
                        // date1: that.timed[0],
                        // date2: that.timed[1],
                        isdetail: 1,
                        searchNum: that.input,
                        timeType: that.daytime,
                        hospital_id: that.ks_value,
                        part_id: that.sources,
                        // part_manage: userinfo.part_manage,
                        groupId: that.part_value,
                        search: that.title,
                        curPage: that.currentPage,
                        pageSize: that.pagesize,

                        age: this.nl_value,
                        sex: this.type_name,
                        name: this.xmname,
                        send_num: this.lxfsname,
                        ywyb: this.type_name,
                        sfyh: this.type_name,
                        ywsy: this.type_name,
                        media_form: this.qd_value,
                        hy: this.hy_value,
                        zy: this.zy_value,
                        xl: this.xl_value,
                        xqah: this.xqah_value,
                        cxfs: this.cxtj_value,
                        sjxh: this.sjxh_value,
                        sjyys: this.yys_value,
                        lwhju: this.lwhj_value,
                        device: this.sbmc_value,
                        yhxzwm: this.yhxzwy_value,
                        khgz: this.khgz_value,
                        jbyc: this.ycjb_value,
                        qd: this.qd_value,
                        dataType: this.fas_value,
                        fscs: this.sendNum,
                        // partName: that.qd_val,
                        partName: '',
                        height: that.sgname,
                        weight: that.tzname,
                        base_xx_platform: that.xxpt_value,
                        base_swcj: that.swcj_value,
                        base_sex_num: that.xshpl_value,
                        send_type: that.fs_value,
                        is_tel: this.dhfs_value,
                        is_wx: this.wxfs_value,
                        is_qq: this.qqfs_value,
                        qd: this.qds_value,
                        stage: this.jds_value,
                        is_tg: 1,
                        customer_type: this.searchtype

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.tabloading = false
                        that.loadings = false
                        that.qb = response.data.data.data ? response.data.data.data.length : ''
                        that.lt = response.data.data.lt ? response.data.data.lt.length : ''
                        that.dx = response.data.data.dx ? response.data.data.dx.length : ''
                        that.yd = response.data.data.yd ? response.data.data.yd.length : ''
                        that.qt = response.data.data.qt ? response.data.data.qt.length : ''
                        that.tableData2 = response.data.data.data
                        that.tableDatalt = response.data.data.lt
                        that.tableDatayd = response.data.data.yd
                        that.tableDatadx = response.data.data.dx
                        that.tableDataqt = response.data.data.qt
                        // this.getmiddle()
                    })
                    .catch(error => {})
            },
            search() {
                let that = this
                if (this.countLoading) return 
                that.loadings = true
                this.countLoading = true
                that.qt = ''
                that.yd = ''
                that.dx = ''
                that.lt = ''
                that.qb = ''
                that.count = 0
                if (this.lx_value == 1) {
                    var url = '/admin/pc/sendmsg/getYyList'
                } else {
                    var url = "/admin/pc/sendmsg/getYyList"
                }
                axios
                    .post(url, {
                        is_zyc_yy: this.lx_value,
                        // date1: that.timed[0],
                        // date2: that.timed[1],
                        isdetail: 0,
                        searchNum: that.input,
                        timeType: that.daytime,
                        hospital_id: that.ks_value,
                        part_id: that.sources,
                        // part_manage: userinfo.part_manage,
                        groupId: that.part_value,
                        search: that.title,
                        curPage: that.currentPage,
                        pageSize: that.pagesize,
                        // sessionToken: session_token,
                        // kw_hospital_id: userinfo.hospital_id,
                        age: this.nl_value,
                        sex: this.type_name,
                        name: this.xmname,
                        send_num: this.lxfsname,
                        ywyb: this.type_name,
                        sfyh: this.type_name,
                        ywsy: this.type_name,
                        media_form: this.qd_value,
                        hy: this.hy_value,
                        zy: this.zy_value,
                        xl: this.xl_value,
                        xqah: this.xqah_value,
                        cxfs: this.cxtj_value,
                        sjxh: this.sjxh_value,
                        sjyys: this.yys_value,
                        lwhju: this.lwhj_value,
                        device: this.sbmc_value,
                        yhxzwm: this.yhxzwy_value,
                        khgz: this.khgz_value,
                        jbyc: this.ycjb_value,
                        qd: this.qd_value,
                        dataType: this.fas_value,
                        fscs: this.sendNum,
                        // partName: that.qd_val,
                        partName: '',
                        height: that.sgname,
                        weight: that.tzname,
                        base_xx_platform: that.xxpt_value,
                        base_swcj: that.swcj_value,
                        base_sex_num: that.xshpl_value,
                        send_type: that.fs_value,
                        is_tel: this.dhfs_value,
                        is_wx: this.wxfs_value,
                        is_qq: this.qqfs_value,
                        qd: this.qds_value,
                        stage: this.jds_value,
                        is_tg: 1,

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loadings = false
                        this.countLoading = false
                        that.count = response.data.data
                        that.tableData2 = response.data.data.data
                        // this.getmiddle()
                    })
                    .catch((error) => {
                        
                    })
            },

            handleSelectionChange2(val) {
                this.tableData3 = val
            },
            handleSelectionChangedx(val) {
                let that = this
                that.dxxz = val

            },
            handleSelectionChangewx(val) {
                let that = this
                that.wxxz = val
            },

            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            // 获取省
            getshen() {
                let that = this
                //省
                axios
                    .post("/admin/pc/sendmsg/getProvince_vue", {}, {
                        token: true
                    })
                    .then(response => {
                        that.xzdz_adress1 = response.data.data
                        that.gzdz_adress5 = response.data.data
                    })
                    .catch(error => {})
            },

            //住址5改变
            getlzxx5() {
                let that = this
                that.gzdz2 = ''
                that.gzdz3 = ''
                that.gzdz4 = ''
                that.gzdz_adress6 = []
                that.gzdz_adress7 = []
                that.gzdz_adress8 = []
                if (that.gzdz) {
                    axios
                        .post(apiadmin_url + "5e1450907b307", {
                            hospital_id: userinfo.hospital_id,
                            sessionToken: session_token,
                            kw_hospital_id: userinfo.hospital_id,
                            parentcode: that.gzdz,
                        })
                        .then(response => {
                            that.gzdz_adress6 = response.data.data
                        })
                        .catch(error => {})
                }
            },

            //址2改变
            getlzxx6() {
                let that = this
                that.gzdz3 = ''
                that.gzdz4 = ''
                that.gzdz_adress7 = []
                that.gzdz_adress8 = []
                axios
                    .post(apiadmin_url + "5e1450907b307", {
                        hospital_id: userinfo.hospital_id,
                        sessionToken: session_token,
                        kw_hospital_id: userinfo.hospital_id,
                        parentcode: that.gzdz2,
                    })
                    .then(response => {
                        that.gzdz_adress7 = response.data.data
                    })
                    .catch(error => {})
            },
            //住址3改变
            getlzxx7() {
                let that = this
                that.gzdz4 = ''
                that.gzdz_adress8 = []
                axios
                    .post(apiadmin_url + "5e1450907b307", {
                        hospital_id: userinfo.hospital_id,
                        sessionToken: session_token,
                        kw_hospital_id: userinfo.hospital_id,
                        parentcode: that.gzdz3,
                    })
                    .then(response => {
                        that.gzdz_adress8 = response.data.data
                    })
                    .catch(error => {})
            },
            //住址1改变
            getlzxx1() {
                let that = this
                that.xzdz2 = ''
                that.xzdz3 = ''
                that.xzdz4 = ''
                that.xzdz_adress2 = []
                that.xzdz_adress3 = []
                that.xzdz_adress4 = []
                if (that.xzdz) {
                    axios
                        .post(apiadmin_url + "5e1450907b307", {
                            hospital_id: userinfo.hospital_id,
                            sessionToken: session_token,
                            kw_hospital_id: userinfo.hospital_id,
                            parentcode: that.xzdz,
                        })
                        .then(response => {
                            that.xzdz_adress2 = response.data.data
                        })
                        .catch(error => {})
                }
            },
            //址2改变
            getlzxx2() {
                let that = this
                that.xzdz3 = ''
                that.xzdz4 = ''
                that.xzdz_adress3 = []
                that.xzdz_adress4 = []
                axios
                    .post(apiadmin_url + "5e1450907b307", {
                        hospital_id: userinfo.hospital_id,
                        sessionToken: session_token,
                        kw_hospital_id: userinfo.hospital_id,
                        parentcode: that.xzdz2,
                    })
                    .then(response => {
                        that.xzdz_adress3 = response.data.data
                    })
                    .catch(error => {})
            },
            //住址3改变
            getlzxx3() {
                let that = this
                that.xzdz4 = ''
                that.xzdz_adress4 = []
                axios
                    .post(apiadmin_url + "5e1450907b307", {
                        hospital_id: userinfo.hospital_id,
                        sessionToken: session_token,
                        kw_hospital_id: userinfo.hospital_id,
                        parentcode: that.xzdz3,
                    })
                    .then(response => {
                        that.xzdz_adress4 = response.data.data
                    })
                    .catch(error => {})
            },
            sendUP() {
                // if(this.fs_value)
                // if(this.tableData)
                let that = this
                if (this.tableData3.length == 0) {
                    this.$message({
                        showClose: true,
                        message: '请选择用户'
                    });
                } else {

                    that.drawer = true
                }

            },
            handleClose(done) {
                done()
            },
            getdx() {
                // let that = this
                // axios
                //     .post(apiadmin_url + "5ed4b297e2cf4", {
                //         sessionToken: session_token,
                //         kw_hospital_id: userinfo.hospital_id,
                //         // author: userinfo.name,
                //         // hospital_id: userinfo.hospital_id,
                //         // part_id: 0,
                //         // role_id: null,
                //         // zlk_id: 171
                //         source: "content",
                //         sys_id: 41,
                //         type_id: 159
                //     })
                //     .then(res => {
                //         that.tablechilren = res.data.data
                //         if (that.inInit) {
                //             //第一次加载后设置为false,点击tab的时候不会进入
                //             that.inInit = false;
                //             that.dxleft = that.tablechilren[0].id + '';
                //             that.lefthandleClick();
                //         }

                //     })
                //     .catch(error => {})
            },
            getdx1() {
                // let that = this
                // axios
                //     .post(apiadmin_url + "5ed4b297e2cf4", {
                //         sessionToken: session_token,
                //         kw_hospital_id: userinfo.hospital_id,
                //         // author: userinfo.name,
                //         // hospital_id: userinfo.hospital_id,
                //         // part_id: 0,
                //         // role_id: null,
                //         // zlk_id: 171
                //         source: "content",
                //         sys_id: 41,
                //         type_id: 160
                //     })
                //     .then(res => {
                //         that.tablechilren = res.data.data
                //     })
                //     .catch(error => {})
            },
            getwx() {
                let that = this
                axios
                    .post(apiadmin_url + "5ed4b297e2cf4", {
                        sessionToken: session_token,
                        kw_hospital_id: userinfo.hospital_id,
                        source: "content",
                        sys_id: 41,
                        type_id: 161,
                    })
                    .then(res => {
                        that.wxtablechilren = res.data.data
                    })
                    .catch(error => {})
            },
            getpyq() {
                let that = this
                axios
                    .post(apiadmin_url + "/jinli/getMaterialType", {}, {
                        token: true
                    })
                    .then(response => {
                        that.pyqtablechilren = response.data.data

                    })
                    .catch(error => {})
            },

            lefthandleClick() {
                let that = this
                var arr = ""
                if (that.dxleft == 0) {
                    axios
                        .post('/admin/pc/sendmsg/getData', {

                            // data_class: 2,
                            // type: 0
                            smsType: that.dxleft - 0,
                            type: that.activeName2 - 0,
                            status: 2,
                            source: 1,
                        }, {
                            token: true
                        })
                        .then(res => {
                            that.dxrightcontent = res.data.data
                        })
                        .catch(error => {})
                }
                if (that.dxleft == 1) {
                    axios
                        .post('/admin/pc/sendmsg/getData', {

                            // data_class: 2,
                            // type: 0
                            smsType: that.dxleft - 0,
                            type: that.activeName2 - 0,
                            status: 2,
                            source: 2,
                        }, {
                            token: true
                        })
                        .then(res => {
                            that.dxrightcontent = res.data.data
                        })
                        .catch(error => {})
                }

            },
            lefthandleClick2() {
                let that = this
                var arr = ""
                if (that.dxleft == 0) {
                    axios
                        .post('/admin/pc/sendmsg/getData', {

                            // data_class: 2,
                            // type: 0
                            smsType: that.dxleft - 0,
                            type: that.activeName2 - 0,
                            status: 2,
                            source: 1,
                        }, {
                            token: true
                        })
                        .then(res => {
                            that.dxrightcontent2 = res.data.data
                        })
                        .catch(error => {})
                }
                if (that.dxleft == 1) {
                    axios
                        .post('/admin/pc/sendmsg/getData', {
                            // data_class: 2,
                            // type: 0
                            smsType: that.dxleft - 0,
                            type: that.activeName2 - 0,
                            status: 2,
                            source: 2,
                        }, {
                            token: true
                        })
                        .then(res => {
                            that.dxrightcontent2 = res.data.data
                        })
                        .catch(error => {})
                }

            },
            wxlefthandleClick() {
                let that = this
                axios
                    .post(apiadmin_url + "6041bd1db6317", {
                        sessionToken: session_token,
                        kw_hospital_id: userinfo.hospital_id,
                        data_class: 1,
                        type: 0
                    })
                    .then(res => {
                        that.wxrightcontent = res.data.data.data
                    })
                    .catch(error => {})
            },
            pyqhandleSelect() {
                // let that = this
                // axios
                //     .post(apiadmin_url + "6041d70ed1be9", {
                //         lzx_id: this.zlzx_value,
                //         data_class: an,
                //         sessionToken: session_token,
                //         kw_hospital_id: userinfo.hospital_id,
                //         material_type:arr,
                //         label:obj
                //     })
                //     .then(res => {
                //         that.wxrightcontent = res.data.artres
                //     })
                //     .catch(error => {})
            },
            handleClick(index) {
                let that = this
                if (index.name == 1) {
                    that.getdx()
                }
                if (index.name == 2) {
                    that.getwx()
                }
                if (index.name == 3) {
                    that.getpyq()
                }
            },
            handleClick2(index) {
                let that = this
                if (index.name == 1) {
                    that.getdx()
                }
                if (index.name == 2) {
                    that.getdx1()
                }
            },
            handleOpen() {

            },
            handleCloses() {},
            wxfs() {
                let that = this

                if (that.wxxz.length != 1) {
                    this.$message({
                        showClose: true,
                        message: '仅可选择一条数据'
                    });
                } else {

                    this.$confirm('确定发送微信', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        var wxcontent = []


                        this.tableData3.forEach(e => {
                            wxcontent.push({
                                id: e.id,
                                wx: e.wx
                            })
                        })
                        // wxcontent = [{
                        //     id: idwx,
                        //     wx: wxh
                        // }    
                        // ]


                        // let idd = []
                        // let nrs = []
                        // that.wxxz.forEach(e => {
                        //     idd.push(e.id)
                        //     nrs.push(e.content)
                        // })
                        // wxnr = {
                        //     id: idd,
                        //     content: nrs
                        // }
                        let wxnr = {
                            id: that.wxxz[0].id,
                            content: that.wxxz[0].content
                        }

                        axios
                            .post(apiadmin_url + "6041f6a46ad3a", {
                                sessionToken: session_token,
                                kw_hospital_id: userinfo.hospital_id,
                                dataSource: that.lx_value,
                                author: userinfo.name,
                                send_data: wxcontent,
                                content: wxnr
                            }).then(res => {
                                this.$message({
                                    type: 'success',
                                    message: '发送成功!'
                                });
                            }).catch(error => {})

                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    });
                }

            },
            dxfs2() {
                let that = this

                if (that.dxxz.length != 1) {
                    this.$message({
                        showClose: true,
                        message: '仅可选择一条数据'
                    });
                } else {
                    this.$confirm('确定发送通知短信', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let yhxx = []
                        this.tableData3.forEach(e => {
                            yhxx.push({
                                id: e.id,
                                tel: e.tel
                            })
                        })

                        let fasnr = {
                            id: that.dxxz[0].templateid,
                            content: that.dxxz[0].content
                        }
                        axios
                            .post("/admin/pc/sendmsg/sendTextSMS", {

                                is_single: 1,
                                dataSource: that.lx_value,
                                send_data: yhxx,
                                content: fasnr,
                                smsType: that.dxleft == 0 ? 0 : 1
                            }, {
                                token: true
                            }).then(res => {
                                // this.$message({
                                //     type: 'success',
                                //     message: '发送成功!'
                                // });
                                if (res.data.code == 200) {
                                    this.$message({
                                        showClose: true,
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.data.msg,
                                        type: 'error'
                                    });
                                }
                            }).catch(error => {})

                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    });

                }

            },

            dxfs() {
                let that = this

                if (that.dxxz.length != 1) {
                    this.$message({
                        showClose: true,
                        message: '仅可选择一条数据'
                    });
                } else {
                    this.$confirm('确定发送营销短信', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let yhxx = []
                        this.tableData3.forEach(e => {
                            yhxx.push({
                                id: e.id,
                                tel: e.tel
                            })
                        })

                        let fasnr = {
                            id: that.dxxz[0].templateid,
                            content: that.dxxz[0].content
                        }
                        axios
                            .post('/admin/pc/sendmsg/sendTextSMS', {
                                is_single: 0,
                                dataSource: that.lx_value,
                                send_data: yhxx,
                                content: fasnr,
                                smsType: that.dxleft == 0 ? 0 : 1
                            }, {
                                token: true
                            }).then(res => {
                                if (res.data.code == 200) {
                                    this.$message({
                                        showClose: true,
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.data.msg,
                                        type: 'error'
                                    });
                                }

                            }).catch(error => {})

                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    });

                }

            },
            yyshandleClick() {

            }
        },
    };
</script>
<style lang="scss" scoped>
    .index {
        #app {
            padding: 10px;
        }

        .leftbox {
            display: flex;
            flex-direction: column;
        }

        .bqys {
            margin-left: 10px;
        }

        .bwidths {
            width: 110px !important;
        }

        .item {
            margin-top: 0px;
            margin-right: 40px;
        }
    }
</style>